function t(e) {
  return e.data;
}
export {
  t as default
};
//# sourceMappingURL=index.es34.js.map
